import React from 'react';
import { List, Filter, TextInput, Datagrid, TextField, FunctionField } from 'react-admin';


const ProjectFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);


export const ProjectList = (props: any) => (
  <List {...props} filters={<ProjectFilter />} perPage={50}>
    <Datagrid rowClick={(id, basePath, record) => `${record.id}`}>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="billingAccount.name" />
      <TextField source="folderId" />
      <TextField source="projectDatawareHouseId" />
      <TextField source="region" />
      <FunctionField
        label="LLM"
        render={(record: any) =>
          record.llm?.status === 'active' ? 'Oui' : '—'
        }
      />
    </Datagrid>
  </List>
);